import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Skeleton, Tree, Row, Col, Divider, Timeline } from "antd";
import { getlog } from "../../../actions/userlogAction";
import dateFormat from "dateformat";
import moment from "moment";

const List = ({ getlog, ID }) => {
  const [data, setdata] = useState();
  const [loading, setloading] = useState(true);
  const pageno = useRef(1);
  const page_size = useRef(100);

  useEffect(() => {
    getlog(pageno.current, page_size.current, 17, ID).then((result) => {
      setdata(result);
      console.log(result);
      setloading(false);
    });
  }, []);

  const rendertable = (details) => {
    for (let key in details) {
      if (details.hasOwnProperty(key)) {
        console.log(key + ":");
        console.log("  Old Value: " + details[key].oldValue);
        console.log("  New Value: " + details[key].newValue);
      }
    }
  };

  if (loading) {
    return <Skeleton active />;
  } else {
    return (
  <>
    <h3>History</h3>
    <Timeline>
      {data.results.map((item) => {
        console.log("Processing item:", item);
        
        let event = item.action.split(" ")[0];
        console.log("Event extracted:", event);
        
        let details = {};
        
        const matches = item.action.match(/\(([^)]+)\)/g);
        
        if (matches && matches.length > 0) {
          const lastMatch = matches[matches.length - 1];
          const detailsString = lastMatch.slice(1, -1);
          
          console.log("Details string:", detailsString);
          
          const items = detailsString.split(/, /);
          
          items.forEach(itemStr => {
            const colonIndex = itemStr.indexOf(': ');
            if (colonIndex !== -1) {
              const key = itemStr.substring(0, colonIndex).trim();
              const valuesStr = itemStr.substring(colonIndex + 2);
              
              if (valuesStr.includes(' -> ')) {
                const [oldValue, newValue] = valuesStr.split(' -> ');
                details[key] = {
                  oldValue: oldValue.trim(),
                  newValue: newValue.trim(),
                };
              } else {
                details[key] = {
                  oldValue: '-',
                  newValue: valuesStr.trim(),
                };
              }
            }
          });
        }
        
        console.log("Parsed details:", details);

        let createData = null;

        if (item.action_type === "create") {
          try {
            let fixed = item.action_data
              .replace(/'/g, '"')                
              .replace(/\"([^\"]*)\":/g, '"$1":') 
              .replace(/None/g, 'null');         

            createData = JSON.parse(fixed);

          } catch (err) {
            console.error("Failed to parse action_data:", err);
          }
        }
        
        return (
          <Timeline.Item color={item.action_type === "create" ? "blue" : "green"} key={item.id}>
            <Row>
              <Col flex="auto">
                <h5>
                  {event} by {item.created_by}
                </h5>
              </Col>
              <Col flex="200px">
                <h5>{moment(item.timestamp).format("YYYY-MM-DD hh:mm A")}</h5>
              </Col>
            </Row>

            {/* ---------- CREATE TYPE ---------- */}
            {item.action_type === "create" && (
              <div style={{ marginTop: "10px", fontSize: "10px", color: "green" }}>
                {item.action}
              </div>
            )}

            {/* ---------- UPDATE TYPE ---------- */}
            {item.action_type === "update" && Object.keys(details).length > 0 && (
              <table style={{ width: "100%", marginTop: "10px", borderCollapse: "collapse", fontSize: "10px" }}>
                <thead>
                  <tr style={{ borderBottom: "1px solid #ddd" }}>
                    <th style={{ textAlign: "left", padding: "8px" }}>Field</th>
                    <th style={{ textAlign: "left", padding: "8px" }}>Old Value</th>
                    <th style={{ textAlign: "left", padding: "8px" }}>New Value</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(details).map(([key, value]) => (
                    <tr key={key} style={{ borderBottom: "1px solid #f0f0f0" }}>
                      <td style={{ padding: "8px" }}><strong>{key}</strong></td>
                      <td style={{ padding: "8px" }}>{value.oldValue}</td>
                      <td style={{ padding: "8px" }}>{value.newValue}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Timeline.Item>
        );
      })}
    </Timeline>
  </>
);
  }
};

export default connect(null, {
  getlog,
})(List);
